// extracted by mini-css-extract-plugin
export var centerText = "_bs-8";
export var container = "_bs-0";
export var doughnutContainer = "_bs-7";
export var legend = "_bs-a";
export var legendItemColorDisplay = "_bs-b";
export var legendItemLabel = "_bs-d";
export var legendItemValue = "_bs-c";
export var lg = "_bs-5";
export var maxWidth = "_bs-9";
export var md = "_bs-4";
export var responsive = "_bs-6";
export var sm = "_bs-3";
export var xs = "_bs-2";
export var xxs = "_bs-1";